import React from "react";
import { Link } from "react-router-dom";

type Props = {
  to: string;
  children: React.ReactNode;
};

const McBackLink: React.FC<Props> = ({ to, children }) => (
  <Link to={to} className="mc-back">
    <span aria-hidden="true">‹</span>
    {children}
  </Link>
);

export default McBackLink;
